module.exports = "<div class=\"container\">\n  <div ng-if=\"filesCtrl.files.length>0\">\n    <h2 translate>Fichiers:</h2>\n    <ul>\n      <li ng-repeat=\"file in filesCtrl.files\">\n        <i\n          class=\"fa fa-download\"\n          aria-hidden=\"true\"\n          style=\"margin-right: 5px\"\n        ></i>\n        <a href=\"{{file.url}}\" target=\"_blank\" download\n          >{{file.originalname}}</a\n        >\n      </li>\n    </ul>\n  </div>\n\n  <div ng-if=\"filesCtrl.notFound\">\n    <h1 align=\"center\">404</h1>\n    <h1 align=\"center\">Page not found</h1>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/files/files.html
// module id = 181
// module chunks = 0